/**
 * This file handles the range slider functionality
 */

import {gsap} from 'gsap';

( function() {

	const slider = document.getElementById('sidebar-slide');

	if(slider) {

		const colourBar = document.getElementById('ColourBar');
		const colours = ['#FD4E27', '#FFEF46', '#1DD861', '#005EEE', '#8B3BE3'];

		const tl = gsap.timeline({paused: true, repeat: -1});

		colours.forEach((colour) => {
			tl.to(colourBar, {backgroundColor: colour, duration: 0.5});
		});

		slider.addEventListener('change', (e) => {

			const val = e.currentTarget.value;

			if(val < colours.length) {
				tl.pause();
				gsap.to(colourBar, { backgroundColor: colours[e.currentTarget.value] });
			} else {
				tl.play();
			}

		});

	}

}() );
